// @flow
import * as React from "react";
import tw from "tailwind-styled-components";

import BaseField, { type Props as BaseFieldProps } from "./BaseField";

type Option = {
  value: string,
  label?: ?string,
  disabled?: boolean,
};

export type Props = {
  ...BaseFieldProps,
  options: Array<Option>,
  value?: string,
  showPlaceholder?: boolean,
  placeholder?: string,
  disabled?: boolean,
};

const StyledSelect = tw.select`
  form-input
  focus:!border-primary
  focus:shadow-[0_0_0_2px_rgba(5,130,255,0.08)]
  border
  block
  w-full
  transition
  duration-150
  ease-in-out
  sm:text-sm
  sm:leading-5
  ${(props: { $hasError?: boolean }) =>
    props.$hasError ? "border-red-500" : ""};
`;

function SelectField({
  horizontal,
  label,
  options,
  semibold,
  smallLabel,
  showPlaceholder,
  placeholder = "-- Select --",
  hasError,
  errorLabel,
  value,
  ...rest
}: Props): React.Node {
  return (
    <BaseField
      errorLabel={errorLabel}
      hasError={hasError}
      horizontal={horizontal}
      label={label}
      semibold={semibold}
      smallLabel={smallLabel}
    >
      <StyledSelect
        {...rest}
        $hasError={hasError}
        className={showPlaceholder && !value ? "text-gray-400" : ""}
        value={value}
      >
        {showPlaceholder && (
          <option key="" value="">
            {placeholder}
          </option>
        )}
        {options.map(({ value, label, disabled }) => (
          <option disabled={disabled} key={value} value={value}>
            {label || value}
          </option>
        ))}
      </StyledSelect>
    </BaseField>
  );
}

export default SelectField;
